import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { RegisterData, RegisterResponseApi } from "../interfaces/register.interface";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class RegisterService {
  private apiUrl = `${environment.apiUrl}/user/register`;

  constructor(private http: HttpClient) { }

  register(data: RegisterData): Observable<RegisterResponseApi> {
    return this.http.post<RegisterResponseApi>(this.apiUrl, data);
  }
}